
import React, {Component } from 'react';

class Metrics extends Component {

    constructor() {
        super();

        setTimeout(() => {
            const classes = ['shipments', 'tonnes', 'products'];
            for(let cl of classes) {
                let counter = 0;
                // Max amount of times we should fire...
                const maxFireCount = 3;
                const observer = new IntersectionObserver((entries, observer) => {
                    counter++;
                    if (counter > maxFireCount) {
                        entries.forEach(entry => {
                            entry.target.classList.add(cl, entry.isIntersecting);
                        });
                        return;
                    }
                    entries.forEach(entry => {
                        entry.target.classList.toggle(cl, entry.isIntersecting);
                    });
                });
                const options = { root: null, rootMargin: '0px', threshold: 1 };
                const elements = document.querySelectorAll(`.${cl}`);
                elements.forEach(el => {
                    observer.observe(el, options);
                });
            }
        }, 1000)
    }

    render(){
        return(
            <div>
                <section className="metrics_area">
                    <div className="container justify-content-center">
                        <div className="row mb_20 justify-content-center" >
                            <div className="col-lg-8">
                                <div class="hemdahl-text mid-size-text justify-content-center">We have analyzed thousands of reefer datalogs including temperature, atmosphere and GPS records. Our product database now includes more than 200 products.</div>
                            </div>
                        </div>
                        <div className="row justify-content-center p-3">
                            <div className="col-md-2 header-text-2">
                                <h1 className="t_color3 wow fadeInUp header-text-2 shipments" data-wow-delay="0.2s"> </h1>
                                <div class="hemdahl-text small-size-text justify-content-center" >Shipments Analyzed</div>
                            </div>
                            <div className="col-md-2 header-text-2">
                                <h1 className="t_color3 wow fadeInUp header-text-2 tonnes" data-wow-delay="0.2s"> </h1>
                                <div class="hemdahl-text small-size-text justify-content-center">Tonnes of Produce Checked</div>
                            </div>
                            <div className="col-md-2 header-text-2">
                                <h1 className="t_color3 wow fadeInUp header-text-2 products" data-wow-delay="0.2s"> </h1>
                                <div class="hemdahl-text small-size-text justify-content-center">Products Supported</div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

export default Metrics;
